/**
 * The workspace in Or's design.
 *
 * His mockup does not cover this screen — the review journey stops at the
 * report — so this is his VOCABULARY (cards, teal eyebrows, ruled rows)
 * applied to the content Q13 specifies: current and previous dated lists,
 * saved reports, and the next delivery time.
 */

import React from 'react';
import { copyFor, SHARED } from '../audienceCopy';

const formatDay = (value) => {
  if (!value) return null;
  try {
    return new Date(value).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  } catch { return null; }
};

// Same signature as `WorkspaceStep`, so the swap in CampaignPage is a
// drop-in and neither design can be handed a shape the other cannot read.
export default function MockWorkspace({ audience, workspace, onOpenList, onOpenReport }) {
  const copy = copyFor(audience);
  const { lists = [], reports = [], nextDeliveryAt, access = {} } = workspace || {};
  const expired = access.enrolled && access.expired;

  return (
    <>
      <p className="mk-eyebrow">Your workspace</p>
      <h1 className="mk-h1 mk-h1--sm">{copy.workspaceTitle}</h1>

      {expired ? (
        <div className="mk-card" style={{ marginBottom: 24 }}>
          <h2 className="mk-h2">{SHARED.expiredTitle}</h2>
          <p className="mk-body">{SHARED.expiredBody}</p>
        </div>
      ) : nextDeliveryAt && (
        <p className="mk-lede">Your next list arrives {formatDay(nextDeliveryAt)}.</p>
      )}

      <div className="mk-card">
        <p className="mk-eyebrow">Your lists</p>
        {lists.length === 0 ? (
          <p className="mk-help">Your first list will appear here.</p>
        ) : lists.map((list) => (
          <div className="mk-row" key={list.listId}>
            <div className="mk-row-main">
              <p className="mk-h3" style={{ margin: 0 }}>{formatDay(list.date) || 'List'}</p>
              <p className="mk-note" style={{ marginTop: 2 }}>
                {list.count === 1 ? '1 opportunity' : `${list.count} opportunities`}
              </p>
            </div>
            <button type="button" className="mk-btn mk-btn--ghost" onClick={() => onOpenList(list.listId)}>
              Open
            </button>
          </div>
        ))}
      </div>

      <div className="mk-card">
        <p className="mk-eyebrow">Your research</p>
        {reports.length === 0 ? (
          <p className="mk-help">Research you create will be saved here.</p>
        ) : reports.map((report) => (
          <div className="mk-row" key={report.reportId}>
            <div className="mk-row-main">
              <p className="mk-h3" style={{ margin: 0 }}>{report.storyTitle || 'Research'}</p>
              <p className="mk-note" style={{ marginTop: 2 }}>
                {report.status === 'ready' ? formatDay(report.readyAt)
                  : report.status === 'failed' ? 'Did not finish' : 'Preparing'}
              </p>
            </div>
            <button
              type="button"
              className="mk-btn mk-btn--ghost"
              onClick={() => onOpenReport(report.reportId)}
              disabled={report.status !== 'ready'}
            >
              Open
            </button>
          </div>
        ))}
      </div>

      <p className="mk-note">{copy.workspaceWiderPlatform}</p>
    </>
  );
}
